import { render, staticRenderFns } from "./ImgCode.vue?vue&type=template&id=02bf7614&scoped=true&"
import script from "./ImgCode.vue?vue&type=script&lang=js&"
export * from "./ImgCode.vue?vue&type=script&lang=js&"
import style0 from "./ImgCode.vue?vue&type=style&index=0&id=02bf7614&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bf7614",
  null
  
)

export default component.exports